enum EnvironmentHostName {
    LOCAL = 'localhost',
    DEV = 'dev.onboarding.gls-group.com',
    STAGE = 'stage.onboarding.gls-group.com',
    MT1 = 'mt1.onboarding.gls-group.com',
    PROD = 'onboarding.gls-group.com'
}

export default EnvironmentHostName;
